module.exports = __webpack_public_path__ + "static/media/twit.1721a1b3.svg";